import React from "react";
import SearchBox from "../../../../../common/SearchBox";
import styles from "../../../styles";
import { withStyles, Button } from "@material-ui/core";
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const localStyles = (_theme) => ({
  container: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
});

const Header = ({
  isDataLoaded,
  classes,
  gridApi,
  updateQuickFilterText,
  openAddTerminalPanel,
}) => {
  return (
    <div className={`${classes.gridHead} ${classes.container}`}>
      <SearchBox onChange={updateQuickFilterText} />
      <ClearAllFilterButton gridApi={gridApi} />
      <div className={classes.actionContainer}>
        <Button
          color="primary"
          variant="contained"
          size="small"
          classes={{ root: classes.actionButton, disabled: classes.actionDisabled }}
          onClick={openAddTerminalPanel}
          data-automationid="addAccessibleTerminals"
          disabled={!isDataLoaded}
        >
          Add Accessible Terminal
        </Button>
      </div>
    </div>
  );
};

export default withStyles((theme) => ({
  ...styles(theme),
  ...localStyles(theme),
}))(Header);
